import { IAddress, ICoordinateGis, IMapPoint, IPhoto } from '../interfaces';

export class MapPoint implements IMapPoint {
  id: number;
  coordinates: ICoordinateGis;
  name: string;
  description?: string;
  location?: string;
  address?: IAddress;
  photos: IPhoto[] = []; // array of URL key strings and captions
  rating?: number;
  ratingCount?: number;
  distance?: number; // distance is miles from center of search area

  constructor(data?: IMapPoint) {
    if (data) {
      this.setData(data);
    }
  }

  setData(data: IMapPoint): void {
    for (const key in data) {
      if (Object.prototype.hasOwnProperty.call(data, key)) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (this as any)[key] = (data as any)[key];
      }
    }

    if (!this.photos) {
      this.photos = [];
    }
  }
}
